import { render, staticRenderFns } from "./x-dynamic-column.vue?vue&type=template&id=1cf7606a"
import script from "./x-dynamic-column.vue?vue&type=script&lang=js"
export * from "./x-dynamic-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports